module.exports = __webpack_public_path__ + "static/media/ic-video.37637c97.svg";